Vendd.Scripts.load(function () {

    var Vendd = window.Vendd || {};

    var attributeEditorContainer = function (element, definition) {

        Vendd.inlineEdit.containerControlBase.apply(this, [element, definition]);

    };
    attributeEditorContainer.prototype = Object.create(Vendd.inlineEdit.containerControlBase.prototype);
    attributeEditorContainer.prototype.name = 'attributeEditorContainer';

    attributeEditorContainer.prototype.render = function () {

        var self = this;

        return Vendd.Promises.GetOrDefault(function() { return Vendd.inlineEdit.containerControlBase.prototype.render.apply(self); })
            .then(function() { self.element.addClass('hidden'); });

    };

    Vendd.inlineEdit.attributeEditorContainer = attributeEditorContainer;

});